// components/TextInputWithHint.tsx
import { Form } from 'react-bootstrap';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

import HintBlock from '@/components/common/HintBlock';

interface TextInputWithHintProps {
  label: string;
  name: string;
  register: UseFormRegisterReturn;
  error?: FieldError;
  max?: number;
  maxLength?: number;
  HintMessage?: string[];
  type?: 'text' | 'number';
  min?: number;
  ErrorMessage?: string;
}

export const TextInputWithHint = ({ label, name, register, error, max, min, maxLength, HintMessage, type, ErrorMessage }: TextInputWithHintProps) => {
  return (
    <Form.Group className="tw-w-full">
      <Form.Label className="tw-text-[#687076] tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none">{label}</Form.Label>
      <Form.Control
        min={min}
        type={type}
        {...register}
        max={max}
        maxLength={maxLength}
        className="tw-self-stretch tw-px-4 tw-py-3 tw-bg-white tw-rounded-md tw-shadow tw-border tw-border-gray-300"
      />
      {HintMessage && <HintBlock texts={HintMessage ?? ['MacBotResponseForm/maxlenght']} />}
      {error && (
        <Form.Control.Feedback type="invalid" className="d-block font-poppins">
          {ErrorMessage ?? error.message}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};
